module.exports = __webpack_public_path__ + "static/media/developerActivity.2b1eaf0b.svg";